<template>
  <div class="submit">
    <!-- <div class="submit-mask" v-show="visible" @click="visible = !visible"></div> -->
    <div class="submit-btn-box">
      <div class="left" v-if="paymentAmount">
        <div class="price-box">
          <span class="price-label">{{$t('components_recharge_submit_409')}}</span>
          <span class="price"
            ><span class="tag">$</span>{{ paymentAmount }}</span
          >
        </div>
        <span class="btn-dropdown" @click="toggleShowDetail"
          >{{$t('components_recharge_submit_410')}}<i class="el-icon-arrow-down" v-show="!visible"></i>
          <i class="el-icon-arrow-up" v-show="visible"></i>
        </span>
      </div>

      <div class="submit-button-group">
        <button
          class="submit-button"
          @click="handleRecharge"
          :style="{ opacity: isPaypal ? 0 : 1 }"
        >{{$t('components_recharge_index_385')}}</button>
      </div>
    </div>
    <div
      class="submit-modal"
      :class="{ 'is-limited-exemption': isLimitedExemption }"
      v-show="visible"
    >
      <template v-if="isLimitedExemption">
        <div class="amount-line-item item">
          <span>{{$t('components_recharge_index_382')}}</span>
          <span class="line"></span>
          <span>{{ paymentAmount - taxation - commission }}</span>
        </div>
        <div class="item amount-line-item">
          <span>{{$t('components_recharge_submit_411')}}</span>
          <span class="line"></span>
          <span>{{ taxation || 0 }}</span>
        </div>
        <div class="item amount-line-item">
          <span>{{$t('components_recharge_submit_412')}}</span>
          <span class="line"></span>
          <span>{{ commission || 0 }}</span>
        </div>
      </template>
      <template v-if="!isLimitedExemption">
        <div class="amount-line-item item">
          <span>{{$t('components_recharge_index_382')}}</span>
          <span class="line"></span>
          <span>{{ paymentAmount - taxation - commission }}</span>
        </div>
        <div class="item flex-between">
          <span>{{$t('components_recharge_submit_413')}}</span>
          <span>{{ taxation || 0 }}</span>
        </div>
        <div class="item flex-between">
          <span>{{$t('components_recharge_submit_414')}}</span>
          <span>{{ commission || 0 }}</span>
        </div>
        <div class="flex-between activity" v-if="giftAmmount">
          <div>
            <span class="tag">{{$t('components_recharge_submit_415')}}</span>
            <span
              >{{$t('components_recharge_submit_416', [ giftAmmount , taxation + commission ])}}</span
            >
          </div>
          <span>0</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Submit',
  props: {
    // 總支付金額
    paymentAmount: {
      type: Number,
      default: 0
    },
    // 稅費
    taxation: {
      type: Number,
      default: 0
    },
    // 手續費
    commission: {
      type: Number,
      default: 0
    },
    // 贈送金額
    giftAmmount: {
      type: Number,
      default: 0
    },
    // 贈送金額
    activitySwitch: {
      type: Boolean,
      default: false
    },
    // 贈送金額
    isPaypal: {
      type: Boolean,
      default: false
    },
    // 是否限免
    isLimitedExemption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {},
  methods: {
    handleRecharge() {
      this.$emit('submit');
    },
    toggleShowDetail() {
      this.visible = !this.visible;
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit {
  width: 53%;
  margin-bottom: 20px;
  font-size: 14px;
  color: $color-gray-3;
  .item {
    margin-bottom: 20px;
    font-size: 14px;
  }
  .submit-modal {
    background: #ffffff;
    border-radius: 26px 26px 0px 0px;
    width: 61%;
    padding: 20px 0 26px 40px;
    font-weight: 400;
    font-size: 15px;
    .amount-line-item {
      display: flex;
      align-items: center;

      .line {
        flex: 1;
        width: 1px;
        display: inline-block;
        border-top: 1px dashed #cbcbcb;
        margin: 0 12px;
      }
    }
    .activity {
      color: #f0548b;
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
      }
      .tag {
        font-size: 12px;
        padding: 4px 8px;
        background-color: #fb5d83;
        border-radius: 20px;
        color: white;
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  .submit-btn-box {
    position: relative;
    z-index: 1;
    padding: 30px 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // width: 600px;
    .left {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // width: 332px;
      // flex: none;
      flex: 1;
    }
    .price-box {
      display: flex;
      align-items: center;
      .price-label {
        padding-right: 12px;
      }
      .price {
        font-size: 23px;
        font-weight: 400;
        color: #fb9030;
      }
      .tag {
        font-size: 18px;
      }
    }

    .btn-dropdown {
      font-size: 14px;
      font-weight: 400;
      padding: 12px;
    }
    .submit-button {
      width: 148px;
      height: 46px;
      background: #f7da5c;
      border-radius: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #0d0d0d;
      font-weight: bold;
    }
  }
}
</style>
